import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientesService } from 'src/app/services/clientes.service';
import { PaquetesService } from 'src/app/services/paquetes.service';
import { environment } from '../../../environments/environment';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { CatalogosService } from 'src/app/services/catalogos.service';

@Component({
  selector: 'app-seleccionar-marco',
  templateUrl: './seleccionar-marco.component.html',
  styleUrls: ['./seleccionar-marco.component.scss']
})
export class SeleccionarMarcoComponent implements OnInit {
  environment = environment.BASE_URL
  currentGrupo:any;
  currentCliente:any;
  currentPaquete:any;

  molduras:any;
  respuestaGet:any;
  data:any;

  constructor(private _plataforma:ClientesService, private _activatedRoute: ActivatedRoute, 
    private _paquetes:PaquetesService, private modalService: NgbModal, private iziToast:Ng2IzitoastService, 
    private router: Router, private _catalogo:CatalogosService) { }

  ngOnInit(): void {
    this.currentGrupo = this._activatedRoute.snapshot.paramMap.get('grupo')
    this.currentCliente = this._activatedRoute.snapshot.paramMap.get('cliente')
    this.currentPaquete = this._activatedRoute.snapshot.paramMap.get('paquete')
    
    this.getMolduras();
  }

  getMolduras(){
    this._plataforma.getMolduras().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.molduras = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarMoldura(moldura){
    this.data = {
        'moldura':moldura, 
        'usuario':this.currentCliente,
        'paquete_cliente': this.currentPaquete,
    }

    this._plataforma.agregarMolduraUsuarioV3(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success ==  '1'){
          this.iziToast.show(
            {
                title: 'Se ha elegido correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          window.location.href='seleccionar-detalles/'+this.currentCliente+'/'+this.currentGrupo+'/'+this.currentPaquete;
      }else {
        alert('No se cargaron los datos');
      }
      }, error => console.error(error)
    )
  }

  async closeSesion() {
    await localStorage.removeItem('token');
    await this.router.navigate(['']);
  }
  

}
